import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  Stack,
  IconButton,
  Divider,
  CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const stageLabels = {
    scriptsAndVisuals: 'Scripts And Visuals',
    voiceOver: 'Voice Over',
    video: 'Video'
};

const ApproveStageModal = ({ open, onClose, onApprove, approveScript, stage, loading }) => {
  const stageLabel = stageLabels[stage] || 'Stage';

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 3
        }}
      >
        {/* Header */}
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h4">Approve {stageLabel}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>

        <Divider sx={{ mb: 2 }} />

        {/* Body */}

        {
          stageLabel == "Scripts And Visuals" &&
          <Typography variant="body1" mb={3}>
            Are you sure you want to approve the <strong>{stageLabel}</strong>?
            After approval, editing the script will be permanently disabled. Please review carefully before proceeding.
          </Typography>
        }
        {
          stageLabel != "Scripts And Visuals" &&
          <Typography variant="body1" mb={3}>
            Are you sure you want to approve the <strong>{stageLabel}</strong>?
            After approval, you will not be able to revert this stage. Proceed only if you’re completely sure.
          </Typography>
        }

        {/* Actions */}
        <Stack direction="row" justifyContent="flex-end" spacing={2}>
          <Button variant="outlined" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          {
            stage == "scriptsAndVisuals" ? 
                <Button
                    variant="contained"
                    onClick={approveScript}
                    disabled={loading}
                    startIcon={
                    loading ? (
                        <CircularProgress size={18} color="inherit" />
                    ) : null
                    }
                >
                    {loading ? 'Approving...' : 'Approve'}
                </Button>
            :
                <Button
                    variant="contained"
                    onClick={() => onApprove(stage)}
                    disabled={loading}
                    startIcon={
                    loading ? (
                        <CircularProgress size={18} color="inherit" />
                    ) : null
                    }
                >
                    {loading ? 'Approving...' : 'Approve'}
                </Button>
          }
        </Stack>
      </Box>
    </Modal>
  );
};

export default ApproveStageModal;
